module.exports = __webpack_public_path__ + "images/1901e59e628326b628a8b13abdcdec9b.svg";